//TODO move path and http_mehtod to a config file

export const acqRequest = async(body, url, http_method) => {

    const payload = JSON.stringify(body);
    console.log(url)
    console.log(payload)
    return fetch(
        url,
        {
            method: http_method,
            headers: {
                'Content-Type': 'application/json'
            },
            body: payload
        }
    ).then(response => response.json()).then(data => {
        console.debug(JSON.stringify(data));
        return data;
    }).catch(error => {
        console.error(error.message);
        throw new Error("Error when requesting: ", error.message);
    });
}

